import { useWidgetData } from '../useWidgetData'

import { StatisticWidget } from '../../../types/widget/widget'

export const useWinRateWidget = () =>
  useWidgetData<StatisticWidget>('win-rate')
